export const GET_FEEDBACKS = 'GET_FEEDBACKS';
export const GET_FEEDBACKS_IS_LOADING = 'GET_FEEDBACKS_IS_LOADING';
export const GET_FEEDBACKS_ERROR = 'GET_FEEDBACKS_ERROR';
